/* @flow weak */
import "babel-polyfill";

export function getXHR(url) {

    return new Promise((fulfill, reject) => {

        var request = new XMLHttpRequest();
        request.open('GET', url, true);

        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                // Success!
                const resData = JSON.parse(request.responseText).data;
                resData ? fulfill(resData) : fulfill(request.responseText) ;
            }
        };

        request.onerror = function() {
            // There was a connection error of some sort
            reject();
        };

        request.send();
    });
}



// WEBPACK FOOTER //
// ./webapp/scripts/XHR.js